export const TABLE_SCOPE = {
  AUDITS: 'audits',
  AUTO_FULFILLMENTS: 'autoFulfillments',
  CARTS: 'carts',
  CATALOGS: 'catalogs',
  COUNTRIES: 'countries',
  CRUD_HELPER: 'crudHelper',
  CURRENCIES: 'currencies',
  CUSTOMER_LIST: 'customerslist',
  CUSTOM_FIELDS_DEFINITION: 'customFieldsDefinition',
  DISCOUNTS: 'discounts',
  DISCOUNT_RULES: 'discountrules',
  EMAIL_BUILDER: 'emailbuilder',
  END_USER_LIST: 'enduserlist',
  END_USER_GROUPS: 'endusergroups',
  FONTS: 'fonts',
  MARKUPS: 'markups',
  GENERATE_CODES: 'generateCodes',
  INVOICE_TRANSLATIONS: 'invoicetranslations',
  LAYOUTS: 'layouts',
  LICENSES: 'licenses',
  LICENSES_DETAILS: 'licensesDetails',
  LICENSES_PROVIDER_DEFINITIONS: 'licenseProviderDefinitions',
  LICENSE_KEYS: 'licensesKeys',
  LOCALES: 'locales',
  MANUAL_FULFILLMENTS: 'manualFulfillments',
  MARKETING_ABANDONED: 'marketingAbandoned',
  LICENSE_EXPIRATION: 'licenseExpiration',
  MARKETING_CAMPAIGNS: 'marketingCampaigns',
  CAMPAIGNS_PRICES: 'campaignsPrices',
  MARKET_PLACE_ORDERS: 'marketplaceorders',
  INVOICES_EXPORT: 'invoicesExport',
  META_ROLES: 'metaRoles',
  NOTIFICATIONS: 'notification-receivers',
  NOTIFICATIONS_DEFINITION: 'notification-definition',
  NOTIFICATIONS_HISTORY: 'notification-history',
  ONBOARDING: 'onboarding',
  ORDER_EVENTS: 'orderEvents',
  ORDER_LIST: 'orderlist',
  ORDER_PRODUCTS: 'orderProducts',
  ORDER_EXPORT: 'orderExport',
  ORDER_CANCELLATIONS: 'orderCancellations',
  REALMS: 'realms',
  RECOMMENDATIONS: 'recommendations',
  REMIT_TABLES: 'remittables',
  PRODUCT_LIST: 'productlist',
  PRICES: 'prices',
  PRICES_FUNCTIONS: 'pricefunctions',
  PRICE_EXPORT: 'priceExport',
  PRIVILEGES: 'privileges',
  RESELLERS: 'resellers',
  ROLES: 'roles',
  STORES: 'stores',
  SUBSCRIPTIONS: 'subscriptions',
  SUBSCRIPTION_MONITORING: 'subscriptionMonitoring',
  SUBSIDIARIES: 'subsidiaries',
  THEMES: 'themes',
  TRANSLATIONS: 'translations',
  USERS: 'users',
  USERS_EMAILS: 'usersEmails',
  USER_ROLES_PROFILES: 'user-roles-profiles',
  END_USERS_WALLET: 'endUsersWallet',
  TNC_MANAGER_RUNNING: 'tncrunning',
  TNC_MANAGER_DRAFT: 'tncdraft',
  TNC_MANAGER_ARCHIVED: 'tncarchived',
  SUBSCRIPTION_EVENTS: 'subscriptionEvents',
  EXPORT_MANAGEMENT_SUBSCRIPTIONS: 'exportManagementSubscriptions',
  EXPORT_MANAGEMENT_PRODUCTS: 'exportManagementProducts',
  EXPORT_MANAGEMENT_DISCOUNT_RULES: 'exportManagementDiscountRules',
  // ROLE: 'role',
};

const VALID_REFRESH_SCOPES = [
  TABLE_SCOPE.PRODUCT_LIST,
  TABLE_SCOPE.CATALOGS,
  TABLE_SCOPE.STORES,
  TABLE_SCOPE.ORDER_LIST,
  TABLE_SCOPE.NOTIFICATIONS,
  TABLE_SCOPE.NOTIFICATIONS_DEFINITION,
  TABLE_SCOPE.NOTIFICATIONS_HISTORY,
  TABLE_SCOPE.CARTS,
  TABLE_SCOPE.LICENSES,
  TABLE_SCOPE.RECOMMENDATIONS,
  TABLE_SCOPE.MARKETING_ABANDONED,
  TABLE_SCOPE.RESELLERS,
  TABLE_SCOPE.END_USER_GROUPS,
  TABLE_SCOPE.CUSTOMER_LIST,
  TABLE_SCOPE.MARKETING_CAMPAIGNS,
  TABLE_SCOPE.EMAIL_BUILDER,
  TABLE_SCOPE.DISCOUNT_RULES,
  TABLE_SCOPE.DISCOUNTS,
  TABLE_SCOPE.ROLES,
  TABLE_SCOPE.META_ROLES,
  TABLE_SCOPE.PRIVILEGES,
  TABLE_SCOPE.REMIT_TABLES,
  TABLE_SCOPE.AUDITS,
  TABLE_SCOPE.ONBOARDING,
  TABLE_SCOPE.TRANSLATIONS,
  TABLE_SCOPE.INVOICE_TRANSLATIONS,
  TABLE_SCOPE.USERS,
  TABLE_SCOPE.REALMS,
  TABLE_SCOPE.CURRENCIES,
  TABLE_SCOPE.LOCALES,
  TABLE_SCOPE.COUNTRIES,
  TABLE_SCOPE.SUBSIDIARIES,
  TABLE_SCOPE.CRUD_HELPER,
  TABLE_SCOPE.MARKET_PLACE_ORDERS,
  TABLE_SCOPE.CUSTOM_FIELDS_DEFINITION,
  TABLE_SCOPE.TNC_MANAGER_RUNNING,
  TABLE_SCOPE.TNC_MANAGER_DRAFT,
  TABLE_SCOPE.TNC_MANAGER_ARCHIVED,
  TABLE_SCOPE.LICENSE_EXPIRATION,
];

const VALID_FILTER_SCOPES = [
  TABLE_SCOPE.PRODUCT_LIST,
  TABLE_SCOPE.CATALOGS,
  TABLE_SCOPE.STORES,
  TABLE_SCOPE.SUBSCRIPTIONS,
  TABLE_SCOPE.LICENSES,
  TABLE_SCOPE.THEMES,
  TABLE_SCOPE.LAYOUTS,
  TABLE_SCOPE.FONTS,
  TABLE_SCOPE.MARKUPS,
  TABLE_SCOPE.TRANSLATIONS,
  TABLE_SCOPE.ORDER_LIST,
  TABLE_SCOPE.NOTIFICATIONS,
  TABLE_SCOPE.NOTIFICATIONS_DEFINITION,
  TABLE_SCOPE.NOTIFICATIONS_HISTORY,
  TABLE_SCOPE.CARTS,
  TABLE_SCOPE.PRICES,
  TABLE_SCOPE.PRICES_FUNCTIONS,
  TABLE_SCOPE.AUTO_FULFILLMENTS,
  TABLE_SCOPE.MANUAL_FULFILLMENTS,
  TABLE_SCOPE.MARKETING_CAMPAIGNS,
  TABLE_SCOPE.LICENSES_PROVIDER_DEFINITIONS,
  TABLE_SCOPE.RECOMMENDATIONS,
  TABLE_SCOPE.MARKETING_ABANDONED,
  TABLE_SCOPE.LICENSE_EXPIRATION,
  TABLE_SCOPE.RESELLERS,
  TABLE_SCOPE.END_USER_LIST,
  TABLE_SCOPE.END_USER_GROUPS,
  TABLE_SCOPE.CUSTOMER_LIST,
  TABLE_SCOPE.EMAIL_BUILDER,
  TABLE_SCOPE.DISCOUNT_RULES,
  TABLE_SCOPE.DISCOUNTS,
  TABLE_SCOPE.ROLES,
  TABLE_SCOPE.META_ROLES,
  TABLE_SCOPE.PRIVILEGES,
  TABLE_SCOPE.REMIT_TABLES,
  TABLE_SCOPE.AUDITS,
  TABLE_SCOPE.ONBOARDING,
  TABLE_SCOPE.INVOICE_TRANSLATIONS,
  TABLE_SCOPE.USERS,
  TABLE_SCOPE.REALMS,
  TABLE_SCOPE.CURRENCIES,
  TABLE_SCOPE.LOCALES,
  TABLE_SCOPE.COUNTRIES,
  TABLE_SCOPE.SUBSIDIARIES,
  TABLE_SCOPE.MARKET_PLACE_ORDERS,
];

const KNOWN_REALMS = ['/nexway', '/mynexway', '/kasperskyfrance'];

const VALID_SEARCH_SCOPES = [
  TABLE_SCOPE.ORDER_LIST,
  TABLE_SCOPE.SUBSCRIPTIONS,
  TABLE_SCOPE.LICENSES,
  TABLE_SCOPE.CARTS,
  TABLE_SCOPE.STORES,
  TABLE_SCOPE.PRODUCT_LIST,
  TABLE_SCOPE.PRICES,
  TABLE_SCOPE.RECOMMENDATIONS,
  TABLE_SCOPE.DISCOUNT_RULES,
  TABLE_SCOPE.MARKETING_CAMPAIGNS,
  TABLE_SCOPE.MARKETING_ABANDONED,
  TABLE_SCOPE.END_USER_LIST,
  TABLE_SCOPE.END_USER_GROUPS,
  TABLE_SCOPE.RESELLERS,
  TABLE_SCOPE.REALMS,
  TABLE_SCOPE.NOTIFICATIONS_HISTORY,
  TABLE_SCOPE.MARKET_PLACE_ORDERS,
];

const VALID_DUPLICATE_SCOPES = [
  TABLE_SCOPE.DISCOUNT_RULES,
  TABLE_SCOPE.RECOMMENDATIONS,
  TABLE_SCOPE.PRODUCT_LIST,
];

const FETCH_STATUS = {
  NEED_UPDATE: 'needUpdate',
  PENDING: 'pending',
  FULFILLED: 'fulfilled',
  REJECTED: 'rejected',
};

const IS_STAGING = window.env.ENV_MODE === 'staging';
const IS_PRODUCTION = window.env.ENV_MODE === 'production';
const IS_RU_STAGING = window.env.ENV_MODE === 'yandex_staging';
const IS_RU_PRODUCTION = window.env.ENV_MODE === 'yandex_prod';

const PAGES_WITH_SECTIONS = [
  'themes',
  'layouts',
  'fonts',
  'translations',
  'invoicetranslations',
  'prices',
  'pricefunctions',
  'autoFulfillments',
  'manualFulfillments',
  'licenseProviderDefinitions',
  'marketingCampaigns',
  'marketingAbandoned',
  'licenseExpiration',
  'roles',
  'profiles',
  'privileges',
  'notification-receivers',
  'notification-definition',
  'notification-history',
  'currencies',
  'locales',
  'countries',
  'subsidiaries',
  'exportManagementSubscriptions',
  'exportManagementProducts',
  'exportManagementDiscountRules',
  'ordersExportList',
  'ordersExportSearch',
];

const END_USER_TYPE = {
  BUYER: 'BUYER',
  RESELLER_NOT_APPROVED: 'RESELLER_NOT_APPROVED',
  RESELLER: 'RESELLER',
  RESELLER_DECLINED: 'RESELLER_DECLINED',
};

const TABLE_DATE_FORMAT = 'D MMM YYYY';
const EVENT_TYPE = {
  FAILED_EVENT: 'failed_event',
  ALL_COMPLETED: 'all_completed',
};

const EVENT_STATUS = {
  FAILED: 'Failed',
  COMPLETED: 'Completed',
};

export {
  VALID_REFRESH_SCOPES,
  VALID_FILTER_SCOPES,
  KNOWN_REALMS,
  VALID_SEARCH_SCOPES,
  VALID_DUPLICATE_SCOPES,
  FETCH_STATUS,
  IS_STAGING,
  IS_PRODUCTION,
  IS_RU_STAGING,
  IS_RU_PRODUCTION,
  PAGES_WITH_SECTIONS,
  END_USER_TYPE,
  TABLE_DATE_FORMAT,
  EVENT_TYPE,
  EVENT_STATUS,
};
